import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';

interface PresentingBadgeProps {
    /** The presenter's display name, or undefined when the local user presents. */
    presenterName?: string;
}

/**
 * Top-start badge over the stage indicating who is sharing their screen
 * ("{Name} is presenting" / "You are presenting").
 */
const PresentingBadge: React.FC<PresentingBadgeProps> = ({ presenterName }) => {
    const { i18next } = useAppContext();
    const label = presenterName
        ? i18next.t('videoconference.presenting.member_is_presenting', {
              Name: presenterName,
          })
        : i18next.t('videoconference.presenting.you_are_presenting');

    return (
        <div className="absolute start-3 top-3 z-20 flex max-w-[60%] items-center gap-2 rounded-md bg-gray-900/80 px-3 py-1.5 text-sm text-white">
            <Icon iconKey="screen_share" size="1rem" />
            <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                {label}
            </span>
        </div>
    );
};

export default PresentingBadge;
